<template>
  <div class="wf-modal" :class="'wf-modal-' + (open ? 'active' : 'inactive')">
    <div class="wf-modal-wrapper wf-modal-wrapper-video" v-if="open">
      <template v-if="videoType == 'youtube'">
        <iframe
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          class="wf-modal-video"
          :src="'https://www.youtube.com/embed/' + videoData + '?autoplay=1'"
        >
        </iframe>
      </template>
      <template v-if="videoType == 'element'">
        <video class="video w-100" controls autoplay>
          <source
            type="video/mp4"
            :src="videoData"
          >
        </video>
      </template>
      <!-- As needed, add other video type templates here -->
      <button class="wf-modal-button-close btn button-full" type="button" @click="close">
        <span class="png-icon png-icon-icons-symbols--k-txtclose " aria-label="Close modal"></span>
      </button>
    </div>
    <div class="wf-modal-lightbox" @click="close">
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      
    }
  },
  computed: {
    ...mapGetters({
      open: 'videoModal/open',
      videoType: 'videoModal/type',
      videoData: 'videoModal/data',
    })
  },
  methods: {
    ...mapActions({
      close: 'videoModal/close'
    })
  }
}
</script>